// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Nav_navbar__1E-lk","brandImage":"Nav_brandImage__3-jEY"};